module.exports = __webpack_public_path__ + "c76eefba22b8f870a6479c92e470e80d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = 570
// module chunks = 0